// extracted by mini-css-extract-plugin
export default {"About":"About_About__gDf+V","content":"About_content__7jLLb"};